import { refetchConnectionToken } from 'vet-bones/utils/portal';

import { connectionsSlice } from 'src/store/connections/connections.slice';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const refreshConnectionToken =
  () => async (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const { connections } = getState();
    const { connection: currentConnection } = connections;

    if (!currentConnection?.token) {
      return null;
    }

    const token = await refetchConnectionToken(currentConnection.index);
    if (!token) {
      return null;
    }

    dispatch(connectionsSlice.actions.updatedConnectionToken({ token }));
    return { ...currentConnection, token };
  };
